/* eslint-disable */

// TODO: 201906111256 - Debe ser dinámico
let periodo = 1;

// Main
import vuex from "vuex"
import vue from "vue"
import vapi from "vuex-rest-api"
vue.use(vuex);

const textos = new vapi({
    state: {
        todos: []
    }
}).get({
    property: "actual",
    action: "texto",
    path: ({ id }) => `/textos/${id}`
})
    .get({
        action: "textosTodos",
        path: function (obj) {
            return `${process.env.VUE_APP_REST}/api/contenido`;
        },
        onSuccess: (state, payload, axios, { params, data }) => {
            state.todos = payload.data;
        }
    })
    .post({
        property: "actual",
        action: "textoActualizar",
        path: ({ id }) => `/textos/${id}`
    })
    .getStore();
    textos.getters = {
        gcontenido: state => {
            return state.todos;
        },
        gcontenido_1: state => {
            return state.todos.filter(p=> p.grupo === '1');
        },
        gcontenido_pdet: (state) => {
            return state.todos.filter((p) => p.grupo === "3");
        },
    }
export default textos;
